






















import Vue from 'vue'
import Component from 'vue-class-component'
import * as config from '@/modules/config'
import SetupGuide from "@/components/SetupGuide.vue";
import {Getter} from "vuex-class";
@Component({
    components: {SetupGuide}
})
export default class App extends Vue {

    @Getter
    public isConfigured: boolean

    public get isConnected () {
        return this.$store.state.connected
    }

    public sentinel: WakeLockSentinel | null = null

    public async created () {
        // Ejecuta la acción que realiza las tareas para el inicio de la aplicación
        await this.$store.dispatch('init')

        await this.wakeLock()

        if (!this.isConfigured && this.$route.name !== 'setup') {
            await this.$router.push({name: 'setup'})
        }
    }

    /**
     * Utiliza la API WakeLock para evitar que la pantalla entre en estado de
     * suspensión y se apague
     */
    public async wakeLock () {
        // El dispositivo no es compatible con WakeLock
        if (!('wakeLock' in navigator)) {
            return
        }

        const requestWakeLock = async () => {
            this.sentinel = await navigator.wakeLock!.request('screen')
            this.sentinel.onrelease = () => {
                this.sentinel = null
            }
        }

        await requestWakeLock()

        // El bloqueo de pantalla es desactivado si la pestaña deja de estar visible
        // Con este evento se volverá a crear un WakeLock cuando la pestaña
        // sea visible de nuevo
        document.addEventListener('visibilitychange', () => {
            if (this.sentinel === null && document.visibilityState === 'visible') {
                requestWakeLock()
            }
        })
    }
}
